import React, { useState, useEffect } from 'react';
import { AdminLayout } from '../../components/admin/AdminLayout';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import { toast } from 'sonner';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const AdminContactInfo = () => {
  const [content, setContent] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    axios.get(`${API}/content/contact_info`).then(r => setContent(r.data)).catch(console.error);
  }, []);

  const set = (key, val) => setContent(prev => ({ ...prev, [key]: val }));

  const save = async () => {
    setSaving(true);
    try {
      await axios.put(`${API}/content/contact_info`, { data: content });
      toast.success('Contact info updated');
    } catch { toast.error('Failed to save'); }
    finally { setSaving(false); }
  };

  if (!content) return <AdminLayout title="Edit Contact Info"><div className="py-8 text-center text-gray-400">Loading...</div></AdminLayout>;

  return (
    <AdminLayout title="Edit Contact Info">
      <div className="max-w-xl space-y-6">
        <Card className="border-2">
          <CardHeader><CardTitle>Phone & Hours</CardTitle></CardHeader>
          <CardContent className="space-y-4">
            <div>
              <Label>Phone Number</Label>
              <Input value={content.phone || ''} onChange={e => set('phone', e.target.value)} className="mt-1" placeholder="919-346-4803" />
            </div>
            <div>
              <Label>Weekday Hours</Label>
              <Input value={content.hours_weekday || ''} onChange={e => set('hours_weekday', e.target.value)} className="mt-1" placeholder="Mon-Fri: 9:00 AM - 6:00 PM" />
            </div>
            <div>
              <Label>Weekend Hours</Label>
              <Input value={content.hours_weekend || ''} onChange={e => set('hours_weekend', e.target.value)} className="mt-1" placeholder="Sat: 10:00 AM - 4:00 PM" />
            </div>
          </CardContent>
        </Card>

        <Card className="border-2">
          <CardHeader><CardTitle>Location</CardTitle></CardHeader>
          <CardContent className="space-y-4">
            <div>
              <Label>Locations (one per line)</Label>
              <textarea
                rows={3}
                value={content.locations || ''}
                onChange={e => set('locations', e.target.value)}
                className="w-full mt-1 px-3 py-2 border rounded-md text-sm"
                placeholder="Henderson, NC&#10;Durham, NC"
              />
            </div>
            <div>
              <Label>Location Note</Label>
              <Input value={content.location_note || ''} onChange={e => set('location_note', e.target.value)} className="mt-1" />
            </div>
          </CardContent>
        </Card>

        <Button onClick={save} disabled={saving} className="bg-red-600 hover:bg-red-700 text-white w-full">
          {saving ? 'Saving...' : 'Save Changes'}
        </Button>
      </div>
    </AdminLayout>
  );
};
